<div class="icon-wrapper">
  <mat-icon>lock</mat-icon>
</div>
